<main id="main-wrapper">
    <div class="master-grid">
        <div class="t-row">
            <div class="col c--12">
                <div class="content-in">
                    <h1 class="central-title">{{ title }}</h1>
                    <div class="normal-txt-in txt-center">
                        <p>
                            Vous pouvez m'écrire directement en utilisant le formulaire d'en bas ou bien depuis n'importe où à l'adresse email : <strong><a target="_blank" href="mailto:superhousni@hotmail.com" class="dk-prim">superhousni@hotmail.com</a></strong>
                        </p>
                        <p>
                            Je suis également disponible sur Facebook, Twitter, LinkedIn et GitHub.<br>
                            Si jamais vous passez aux Comores, faites-moi signe !
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="t-row">
            <div class="col c--12">
                <div class="mrg">
                    <h2 class="second-title">Écrire un message</h2>
                </div>
            </div>
            <div class="col c--6 dsk--6">
                <div class="mrg">
                    <form action="#" class="ct-form">
                        <input type="text" id="inputName" name="inputName" placeholder="Nom & prénom" required>
                        <input type="email" id="inputEmail" name="inputEmail" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" placeholder="Email" required>
                        <input type="text" id="inputObject" name="inputObject" placeholder="Objet">
                        <textarea name="textMsg" id="textMsg" rows="5" placeholder="Votre message" required></textarea>
                        <button class="bt-dk-prim" type="submit">Envoyer</button>
                    </form>
                </div>
            </div>
            <div class="col c--6 dsk--6">
                <div class="mrg">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d62510.54284438735!2d43.223612404825495!3d-11.700862625704398!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1898feade3e34bb1%3A0x3943d96d792e2d3e!2sMoroni%2C+Comores!5e0!3m2!1sfr!2s!4v1565683125578!5m2!1sfr!2s" width="100%" height="385" frameborder="0" style="border:0" allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
</main>